export async function getList({commit}, payload) {
  const {errResponse, data: responseData} = await this.$adminRepositories.metas.index(payload);
  if (!errResponse && responseData.success) {
    return commit('setList', responseData.data);
  }

  return [];
}

export async function createMeta({commit}, payload) {
  commit('setBtnLoading', true, {root: true});
  const response = await this.$adminRepositories.metas.create(payload);
  commit('setBtnLoading', false, {root: true});
  return response;
}

export async function updateMeta({commit}, payload) {
  commit('setBtnLoading', true, {root: true});
  const response = await this.$adminRepositories.metas.update(payload.id, payload);
  commit('setBtnLoading', false, {root: true});
  return response;
}

export async function findMetaById(_, payload) {
  return await this.$adminRepositories.metas.show(payload);
}

export async function deleteMetaById({dispatch}, payload) {
  const response = await this.$adminRepositories.metas.delete(payload.id);
  await dispatch('getList');
  return response;
}

